import { render, staticRenderFns } from "./user_auth_copy.vue?vue&type=template&id=b1908fc0&scoped=true"
import script from "./user_auth_copy.vue?vue&type=script&lang=js"
export * from "./user_auth_copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1908fc0",
  null
  
)

export default component.exports